import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useTestContext } from '../../../context/testContext';
import { visualFieldSetup } from '../../../helpers/data';
import { PanelTitle, RadioGroup, SessionActions, breakpoints } from '../../../ui';
import { StepBody, OptionCard } from '../testScreenKit';

// Step 2 - Visual Field options (no Figma frame; same language as the other setup steps).
const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  width: 100%;
  @media (max-width: ${breakpoints.phone - 1}px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }
`;

const GROUPS = ['contrast', 'fixationType', 'targetDuration', 'responseType', 'contrastType'];

const VisualFieldSetup = ({ eyeTested, updateStep }) => {
  const { updateTestData, testData } = useTestContext();
  const [checkedRadioButtons, setCheckedRadioButtons] = useState({
    contrast: testData[eyeTested]?.contrast || 'maximum contrast',
    targetDuration: testData[eyeTested]?.targetDuration || 200,
    fixationType: testData[eyeTested]?.fixationType || visualFieldSetup.fixationType.options[0].value,
    responseType: testData[eyeTested]?.responseType || 'patient mouse click',
    contrastType: testData[eyeTested]?.contrastType || 'whiteOnBlack',
  });

  const handleSelection = (option, selection) => {
    setCheckedRadioButtons((checkedRadioButtons) => ({ ...checkedRadioButtons, [option]: selection }));
  };

  useEffect(() => {
    updateTestData({ [eyeTested]: checkedRadioButtons });
  }, [checkedRadioButtons, eyeTested, updateTestData]);

  return (
    <StepBody gap={20} data-testid='vf-setup'>
      <PanelTitle small>Choose the test settings</PanelTitle>
      <Grid>
        {GROUPS.map((groupId) => {
          const group = visualFieldSetup[groupId];
          return (
            <OptionCard key={groupId}>
              <legend>{group.name}</legend>
              <RadioGroup
                direction='column'
                name={`vf-${groupId}`}
                ariaLabel={group.name}
                options={group.options.map(({ id, value, label }) => ({ id, value, label }))}
                value={checkedRadioButtons[groupId]}
                onChange={(value) => handleSelection(groupId, value)}
              />
            </OptionCard>
          );
        })}
      </Grid>
      <SessionActions onBack={() => updateStep('eyeSetup')} primary={{ label: 'Next', onClick: () => updateStep(`${eyeTested}Test`) }} />
    </StepBody>
  );
};

export default VisualFieldSetup;
